import {ActiveRecord} from './ActiveRecord';
import config from 'config';

export const KEY_TERMS_CONDITION = 'tc';
export const DATA_SECURITY_CONDITION = 'ds';

export default class Settings extends ActiveRecord {
  static path = `${config.backOfficeBasePath}/preferences`;

  _getModel() {
    return Settings;
  }

  fetch() {
    return Promise.all([
        this._networkLayer.getJson(this._prepareUrl(KEY_TERMS_CONDITION)),
        this._networkLayer.getJson(this._prepareUrl(DATA_SECURITY_CONDITION))
    ])
      .then(([tc, ds]) => this._extendData({
        terms_and_conditions: tc.value,
        data_security: ds.value
      }));
  }

  save() {
    return Promise.all([
      this._networkLayer.postJson(this._prepareUrl(), {
        key: KEY_TERMS_CONDITION,
        value: this.terms_and_conditions
      }),
      this._networkLayer.postJson(this._prepareUrl(), {
        key: DATA_SECURITY_CONDITION,
        value: this.data_security
      })
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/api/settings.js